import { useTheme } from "@emotion/react"
import { Box } from "@mui/material"
import { EmptyData } from "components/EmptyData"
import { Head } from "components/Head"
import { ShopIcon } from "components/icons"
import { MotionDiv } from "components/motions"
import { DepartmentStoreOccupantCard } from "extensions/em-department-store/components/DepartmentStoreOccupantCard"
import { useDepartmentStore } from "extensions/em-department-store/hooks/useDepartmentStore"
import { useTranslation } from "providers/i18n"
import React, { useMemo } from "react"
import { useParams } from "react-router-dom"
import { getIcon } from "utils/icon"

export const EMDepartmentStoreMobileOccupantPage = () => {
  const { departId } = useParams()
  const { occupants } = useDepartmentStore(departId)
  const { t } = useTranslation()
  const theme = useTheme()

  const styleOverrides =
    theme.components[`EmDepartmentStorePage`]?.styleOverrides || {}
  const { occupantCardsContainer, occupantCardWrapper, emptyDataContainer } =
    styleOverrides || {}
  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.department) || <ShopIcon />,
    [theme]
  )
  return (
    <>
      <Head title={t("DepartmentStore")} />
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15 }}
      >
        {occupants?.length === 0 ? (
          <Box sx={emptyDataContainer}>
            <EmptyData
              icon={emptyIcon}
              primary={t("Coming soon")}
              secondary={t("Stay tuned for the update")}
            />
          </Box>
        ) : (
          <Box sx={occupantCardsContainer}>
            {occupants.map((occupant) => (
              <Box sx={occupantCardWrapper} key={occupant.id}>
                <DepartmentStoreOccupantCard data={occupant} />
              </Box>
            ))}
          </Box>
        )}
      </MotionDiv>
    </>
  )
}
